import { TruckDetailsFlyoutPendingStatusSubtitle, TruckDetailsFlyoutPendingStatusTitle } from "constants/text";
import {
	PendingStatusMessage,
	PendingStatusMessageContainer,
	PendingStatusMessageSubtitle,
	PendingStatusMessageTitle
} from "./TruckDetailsFlyoutOrderCardPendingStatusMessage.styles";

const TruckDetailsFlyoutOrderCardPendingStatusMessage = () => {
	return (
		<PendingStatusMessageContainer data-testid="truckDetails-orderCardPendingStatus">
			<img
				src="/assets/trucks/TruckIllustration.svg"
				alt="Processed trucks not found logo"
				data-testid="processed-trucks-not-found-logo"
			/>
			<PendingStatusMessage>
				<PendingStatusMessageTitle>{TruckDetailsFlyoutPendingStatusTitle}</PendingStatusMessageTitle>
				<PendingStatusMessageSubtitle>{TruckDetailsFlyoutPendingStatusSubtitle}</PendingStatusMessageSubtitle>
			</PendingStatusMessage>
		</PendingStatusMessageContainer>
	);
};

export default TruckDetailsFlyoutOrderCardPendingStatusMessage;
